import Wallet from './wallet';

const modelTypes = {
    Wallet
}

export default modelTypes;
